export default {
  ISTQB: "ISTQB retake",
  INSURANCE: "Insurance",
  ADDITIONAL_PROJECT_SESSION: "Additional project session",
  BLOCK_RETAKE: "Block retake",
};
